import * as yup from 'yup';
import { IMAGE_PDF_SUPPORTED_FORMATS, TWO_MB } from '@src/constants';
import { phoneSchemaFactory } from '@src/validations';
import Api from '@sendsprint/api-types';
import { BeneficialOwnerValues } from '../components/controlPersonInformationStep';

const today = new Date(Date.now());

export const getControlPersonInfoSchema = (values: BeneficialOwnerValues) =>
  yup.object().shape({
    shareSize: yup
      .string()
      .required('Please enter percentage')
      .test('LOWEST_PERCENTAGES', 'The minimum percentage of the owner must be 5%', (value) => {
        if (value && Number(value) < 5) {
          return false;
        }
        return true;
      })
      .test('HIGHEST_PERCENTAGES', 'The maximum percentage of the owner must be 100%', (value) => {
        if (value && Number(value) > 100) {
          return false;
        }
        return true;
      }),
    legalFirstName: yup.string().required('Please enter first name'),
    legalLastName: yup.string().required('Please enter last name'),
    dateOfBirth: yup
      .string()
      .required('Date is required')
      // .matches(/^\d{4}-\d{2}-\d{2}$/, 'Date must be in YYYY-MM-DD format')
      .test('MAXIMUM_OF_TODAY', 'The maximum date to be selected is yesterday', (value) => {
        const inputDate = new Date(value || '');
        const today = new Date();
        today.setHours(0, 0, 0, 0); // remove time
        return inputDate < today;
      }),
    country: yup.string().required('Please select country'),
    stateOfResidence: yup.string().required('Please select state'),
    address: yup.string().required('Please enter address'),
    city: yup.string().required('Please enter city'),
    zipCode: yup.string().required('Please enter zip code'),
    email: yup.string().email('Please enter valid email').required('Please enter email'),
    homePhoneNumber: phoneSchemaFactory({
      countryCodeOrPath:
        values?.country === Api.Model.CountryInitials.NigeriaNig
          ? Api.Model.CountryInitials.Nigeria
          : values?.country || '',
      required: true,
      numbersOnly: true
    }),
    occupation: yup.string().required('Please enter occupation'),
    formId: yup.string().required('Please select id'),
    idNumber: yup.string().required('Please enter ID number'),
    agencyApplicationForm: yup
      .mixed()
      .nullable()
      .required('Please add document')
      .test(
        'FILE_FORMAT',
        'Please check the format of the files selected. The supported formats are jpeg, jpg or png.',
        (value) => {
          if (typeof value === 'string') {
            return true;
          }

          if (value) {
            if (!IMAGE_PDF_SUPPORTED_FORMATS.includes(value?.type)) {
              return false;
            }
          }

          return true;
        }
      )
      .test('FILE_SIZE', 'File too big. Maximum of 2mb', (value) => {
        if (typeof value === 'string') {
          return true;
        }

        if (value) {
          if (value.size > TWO_MB) {
            return false;
          }
        }

        return true;
      })
  });
